<!--  Only Large and Normal Desktop HTML5 Goes here... -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex"></div>
      <div class="flex-60">
        <div class="bulletin-header-utilities flex-container">
          <div class="flex">
            <i class="material-icons" (click)='navigateBack()'>arrow_back</i>
          </div>
          <div class="flex">
            <div class="align-right">
              <i class="material-icons" (click)='printBulletin()'>print</i>
              <i class="material-icons pointer" data-toggle="modal" data-target="#shareContent"
                (click)='shareContent(bulletin?.bulletinDisplayId, "bulletin", bulletin?.bulletinType, bulletin?.bulletinDisplayNumber)'>share</i>
              <i class="material-icons" (click)='toggleSave()'>{{this.isBulletinSaved ? 'star': 'star_border'}}</i>
            </div>
          </div>
        </div>

        <div>
          <div *ngIf="APP_SETTINGS.isExternal != 'true'" media="print" class="rating-header align-right">
            <div *ngIf="isRatingDisabled" class="flex-container column" style="border: 1px solid #555555;padding: 5px;">
              Rate this bulletin...where * is poor and ***** is excellent.
              <div>
                <div>
                  <h5 style="color: #ff0000">{{errorMessage}}</h5>
                </div>
                <star-rating [rating]='rating' (ratingClick)='ratingComponentClick($event)'></star-rating>
                <textarea ref-textarea [(ngModel)]="ratingcomments" style="width: 200px"
                  placeholder="Type your comments here" rows="3"></textarea>
              </div>
              <div>
                <button type='submit' (click)='saveRating()' [disabled]='isButtonDisabled'
                  [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                  class="bmw-submit-button">Submit Rating</button>
              </div>
            </div>
          </div>
          <div #bulletinContent>
            <div class="bulletin-header flex-container">

              <div [class]="flexClass">
                <img class="bmw-header-lg-logo" [src]='imgSrc' />
              </div>

              <div class="flex-71" *ngIf="APP_SETTINGS.isMINI == 'true'">
                <div class="bmw-bulletin-sib"
                  [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                  {{bulletin?.bulletinType ? (bulletin?.bulletinType == 'SIB'? 'SIM' : bulletin?.bulletinType)  : ''}}
                  {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}
                  <!-- {{bulletin?.bulletinType ? bulletin?.bulletinType : ''}} {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}-->
                </div>
                <div class="bmw-bulletin-desc">{{bulletin?.description}}</div>
              </div>
              <div class="flex-76"
                *ngIf="APP_SETTINGS.isBMW == 'true' || APP_SETTINGS.isMOTORRAD == 'true' || APP_SETTINGS.isRollsRoyce == 'true'">
                <div class="bmw-bulletin-sib"
                  [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                  {{bulletin?.bulletinType ? bulletin?.bulletinType : ''}}
                  {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}
                </div>
                <div class="bmw-bulletin-desc">{{bulletin?.description}}</div>
              </div>
              <div class="flex-16">
                <div class="bmw-bulletin-date">{{bulletin?.releaseDate | date: 'yyyy-MM-dd'}}</div>
              </div>
            </div>
            <div class="bulletin-content flex-container column" [hidden]="!isLoaded">
              <div *ngFor='let detail of bulletinDetail'>

                <div class="bmw-bulletin-section" *ngIf='detail?.title === "Legacy"'>
                  <!-- <div class="bulletin-detail-title">{{detail?.title}}</div> -->
                  <div style="word-wrap: break-word" [innerHTML]='detail?.descriptionRich'></div>
                </div>

                <div class="bmw-bulletin-section" *ngIf='detail?.title === "Supporting Materials"'>
                  <div class="bulletin-detail-title supporting-materials-padding">{{detail?.title}}</div>
                  <div *ngIf='bulletinFiles?.length > 0'>
                    <div *ngIf='bulletinType.toLowerCase() === "sib"'>
                      <a [href]='"mount/sib_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                        <div class="bmw-bulletin-detail-files">
                          <i class="material-icons"
                            [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                            {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                          </i>
                          <span>{{ file?.fileName }}</span>
                        </div>
                      </a>
                    </div>
                    <div *ngIf='bulletinType.toLowerCase() === "tri"'>
                      <a [href]='"mount/tri_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                        <div class="bmw-bulletin-detail-files">
                          <i class="material-icons"
                            [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                            {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                          </i>
                          <span>{{ file?.fileName }}</span>
                        </div>
                      </a>
                    </div>

                  </div>

                  <div class="bmw-bulletin-section"
                    *ngIf='detail?.videoDisplayNumber && detail?.videoDisplayNumber.length > 0'>
                    <div class="bulletin-detail-title supporting-materials-padding">Videos</div>
                    <!-- <a [href]='"/#/playback?"+videoNumber?.videoLink' target="_blank"
                      *ngFor='let videoNumber of detail?.videoDisplayNumber'> -->
                    <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
                    <!-- <div class="video-link">
                        <span>{{ videoNumber?.videoId }}</span>
                      </div> -->
                    <!--</div> -->
                    <!-- </a> -->

                    <div *ngIf="APP_SETTINGS.isRollsRoyce  == 'true'">
                      <a [href]='"/tisUI/?linemake=ROLLSROYCE#/playback?"+videoNumber?.videoLink' target="_blank"
                        *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                        <div class="video-link">
                          <span>{{ videoNumber?.videoId }}</span>
                        </div>

                      </a>

                    </div>
                    <div *ngIf="APP_SETTINGS.isRollsRoyce  != 'true'">
                      <a [href]='"/tisUI/#/playback?"+videoNumber?.videoLink' target="_blank"
                        *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                        <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
                        <div class="video-link">
                          <span>{{ videoNumber?.videoId }}</span>
                        </div>
                        <!--</div> -->
                      </a>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>

    </div>
    <!-- Modal -->
    <div class="modal fade" id="shareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" #modalCloseButton class="close" data-dismiss="modal"
              style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- Only iPadPro and Medium size Desktop HTML5 Goes here... -->
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bulletin-md-container flex-container row">
      <div class="flex"></div>
      <div class="flex-75" #bulletinContent>
        <div class="bulletin-header-utilities flex-container">
          <div class="flex">
            <i class="material-icons" (click)='navigateBack()'>arrow_back</i>
          </div>
          <div class="flex">
            <div class="align-right">
              <i class="material-icons" (click)='printBulletin()'>print</i>
              <i class="material-icons pointer" data-toggle="modal" data-target="#shareContent"
                (click)='shareContent(bulletin?.bulletinDisplayId, "bulletin", bulletin?.bulletinType, bulletin?.bulletinDisplayNumber)'>share</i>
              <i class="material-icons" (click)='toggleSave()'>{{this.isBulletinSaved ? 'star': 'star_border'}}</i>
            </div>
          </div>
        </div>
        <div>
          <div *ngIf="APP_SETTINGS.isExternal != 'true'" media="print" class="rating-header align-right">
            <div *ngIf="isRatingDisabled" class="flex-container column" style="border: 1px solid #555555;padding: 5px;">
              Rate this bulletin...where * is poor and ***** is excellent.
              <div>
                <div>
                  <h5 style="color: #ff0000">{{errorMessage}}</h5>
                </div>
                <star-rating [rating]='rating' (ratingClick)='ratingComponentClick($event)'></star-rating>
                <textarea ref-textarea [(ngModel)]="ratingcomments" style="width: 200px"
                  placeholder="Type your comments here" rows="3"></textarea>
              </div>
              <div>
                <button type='submit' (click)='saveRating()' [disabled]='isButtonDisabled'
                  [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
                  class="bmw-submit-button">Submit Rating</button>
              </div>
            </div>
          </div>
          <div class="bulletin-header flex-container" >
            <div class="flex-15" *ngIf="APP_SETTINGS.isMINI == 'true'">
              <img class="bmw-header-lg-logo" src='assets/images/MINI_symbol_RGB_black_30px.png' />
            </div>
            <div class="flex-15" *ngIf="APP_SETTINGS.isRollsRoyce  == 'true'">
              <img class="bmw-header-lg-logo" src='assets/images/RR_Small_Logo_Black.png' />
            </div>
            <div class="flex-10" *ngIf="APP_SETTINGS.isBMW == 'true'">
              <img class="bmw-header-lg-logo" src='assets/images/bmw_small_logo.png' />
            </div>
            <div class="flex-71" *ngIf="APP_SETTINGS.isMINI == 'true'">
              <div class="bmw-bulletin-sib"
                [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                {{bulletin?.bulletinType ? (bulletin?.bulletinType == 'SIB'? 'SIM' : bulletin?.bulletinType)  : ''}}
                {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}
              </div>
              <div class="bmw-bulletin-desc">{{bulletin?.description}}</div>
            </div>
            <div class="flex-76"
              *ngIf="APP_SETTINGS.isBMW == 'true' || APP_SETTINGS.isMOTORRAD == 'true' || APP_SETTINGS.isRollsRoyce == 'true'">
              <div class="bmw-bulletin-sib"
                [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                - {{bulletin?.bulletinType ? bulletin?.bulletinType : ''}}
                {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}
              </div>
              <div class="bmw-bulletin-desc">{{bulletin?.description}}</div>
            </div>
            <div class="flex-16">
              <div class="bmw-bulletin-date">{{bulletin?.releaseDate | date: 'yyyy-MM-dd'}}</div>
            </div>
          </div>
          <div class="bulletin-content flex-container column" [hidden]="!isLoaded">
            <div *ngFor='let detail of bulletinDetail'>

              <div class="bmw-bulletin-section" *ngIf='detail?.title === "Legacy"'>
                <!-- <div class="bulletin-detail-title">{{detail?.title}}</div> -->
                <div style="word-wrap: break-word" [innerHTML]='detail?.descriptionRich'></div>
              </div>
              <div class="bmw-bulletin-section" *ngIf='detail?.title === "Supporting Materials"'>
                <div class="bulletin-detail-title supporting-materials-padding">{{detail?.title}}</div>
                <div *ngIf='bulletinFiles?.length > 0'>
                  <div *ngIf='bulletinType.toLowerCase() === "sib"'>
                    <a [href]='"mount/sib_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                      <div class="bmw-bulletin-detail-files">
                        <i class="material-icons"
                          [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                          {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                        </i>
                        <span>{{ file?.fileName }}</span>
                      </div>
                    </a>
                  </div>
                  <div *ngIf='bulletinType.toLowerCase() === "tri"'>
                    <a [href]='"mount/tri_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                      <div class="bmw-bulletin-detail-files">
                        <i class="material-icons"
                          [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                          {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                        </i>
                        <span>{{ file?.fileName }}</span>
                      </div>
                    </a>
                  </div>

                </div>

                <div class="bmw-bulletin-section"
                  *ngIf='detail?.videoDisplayNumber && detail?.videoDisplayNumber.length > 0'>
                  <div class="bulletin-detail-title supporting-materials-padding">Videos</div>
                  <div *ngIf="APP_SETTINGS.isRollsRoyce  == 'true'">
                    <a [href]='"/tisUI/?linemake=ROLLSROYCE#/playback?"+videoNumber?.videoLink' target="_blank"
                      *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                      <div class="video-link">
                        <span>{{ videoNumber?.videoId }}</span>
                      </div>
                    </a>
                  </div>
                  <div *ngIf="APP_SETTINGS.isRollsRoyce  != 'true'">
                    <a [href]='"/tisUI/#/playback?"+videoNumber?.videoLink' target="_blank"
                      *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                      <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
                      <div class="video-link">
                        <span>{{ videoNumber?.videoId }}</span>
                      </div>
                      <!--</div> -->
                    </a>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" #modalCloseButton class="close" data-dismiss="modal"
              style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!--  Only Tablet or iPad HTML5 Goes here... -->
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="bulletin-sm-container flex-container row">
      <div class="bulletin-header-utilities flex-container" #bulletinContent>
        <div class="flex">
          <i class="material-icons" (click)='navigateBack()'>arrow_back</i>
        </div>
        <div class="flex">
          <div class="align-right">
            <i class="material-icons" (click)='printBulletin()'>print</i>
            <i class="material-icons pointer" data-toggle="modal" data-target="#shareContent"
              (click)='shareContent(bulletin?.bulletinDisplayId, "bulletin", bulletin?.bulletinType, bulletin?.bulletinDisplayNumber)'>share</i>
            <i class="material-icons" (click)='toggleSave()'>{{this.isBulletinSaved ? 'star': 'star_border'}}</i>
          </div>
        </div>
      </div>
      <div *ngIf="APP_SETTINGS.isExternal != 'true'" media="print" class="rating-header align-right">
        <div *ngIf="isRatingDisabled" class="flex-container column" style="border: 1px solid #555555;padding: 5px;">          Rate this bulletin...where * is poor and ***** is excellent.
          <div>
            <div>
              <h5 style="color: #ff0000">{{errorMessage}}</h5>
            </div>
            <star-rating [rating]='rating' (ratingClick)='ratingComponentClick($event)'></star-rating>
            <textarea ref-textarea [(ngModel)]="ratingcomments" style="width: 200px"
              placeholder="Type your comments here" rows="3"></textarea>
          </div>
          <div>
            <button type='submit' (click)='saveRating()' [disabled]='isButtonDisabled'
              [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22" : (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
              class="bmw-submit-button">Submit Rating</button>
          </div>
        </div>
      </div>
      <div class="bulletin-header flex-container" >
        <div class="flex-15" *ngIf="APP_SETTINGS.isMINI == 'true'">
          <img class="bmw-header-lg-logo" src='assets/images/MINI_symbol_RGB_black_30px.png' />
        </div>
        <div class="flex-15" *ngIf="APP_SETTINGS.isRollsRoyce  == 'true'">
          <img class="bmw-header-lg-logo" src='assets/images/RR_Small_Logo_Black.png' />
        </div>
        <div class="flex-10" *ngIf="APP_SETTINGS.isBMW == 'true'">
          <img class="bmw-header-lg-logo" src='assets/images/bmw_small_logo.png' />
        </div>
        <div class="flex-71" *ngIf="APP_SETTINGS.isMINI == 'true'">
          <div class="bmw-bulletin-sib"
            [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            {{bulletin?.bulletinType ? (bulletin?.bulletinType == 'SIB'? 'SIM' : bulletin?.bulletinType)  : ''}}
            {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}
            <!--  {{bulletin?.bulletinType ? bulletin?.bulletinType : ''}} {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}-->
          </div>
          <div class="bmw-bulletin-desc">{{bulletin?.description}}</div>
        </div>
        <div class="flex-76"
          *ngIf="APP_SETTINGS.isBMW == 'true' || APP_SETTINGS.isMOTORRAD == 'true' || APP_SETTINGS.isRollsRoyce == 'true'">
          <div class="bmw-bulletin-sib"
            [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
            {{bulletin?.bulletinType ? bulletin?.bulletinType : ''}}
            {{bulletin?.bulletinDisplayNumber?bulletin?.bulletinDisplayNumber:''}}
          </div>
          <div class="bmw-bulletin-desc">{{bulletin?.description}}</div>
        </div>
        <div class="flex-16">
          <div class="bmw-bulletin-date">{{bulletin?.releaseDate | date: 'yyyy-MM-dd'}}</div>
        </div>
      </div>
      <div class="bulletin-content flex-container column"  [hidden]="!isLoaded">
        <div *ngFor='let detail of bulletinDetail'>

          <div class="bmw-bulletin-section" *ngIf='detail?.title === "Legacy"'>
            <!-- <div class="bulletin-detail-title">{{detail?.title}}</div> -->
            <div style="word-wrap: break-word" [innerHTML]='detail?.descriptionRich'></div>
          </div>

          <div class="bmw-bulletin-section" *ngIf='detail?.title === "Supporting Materials"'>
            <div class="bulletin-detail-title supporting-materials-padding">{{detail?.title}}</div>
            <div *ngIf='bulletinFiles?.length > 0'>
              <div *ngIf='bulletinType.toLowerCase() === "sib"'>
                <a [href]='"mount/sib_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                  <div class="bmw-bulletin-detail-files">
                    <i class="material-icons"
                      [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22":(APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                    </i>
                    <span>{{ file?.fileName }}</span>
                  </div>
                </a>
              </div>
              <div *ngIf='bulletinType.toLowerCase() === "tri"'>
                <a [href]='"mount/tri_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                  <div class="bmw-bulletin-detail-files">
                    <i class="material-icons"
                      [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                    </i>
                    <span>{{ file?.fileName }}</span>
                  </div>
                </a>
              </div>

            </div>
            <div class="bmw-bulletin-section"
              *ngIf='detail?.videoDisplayNumber && detail?.videoDisplayNumber.length > 0'>
              <div class="bulletin-detail-title supporting-materials-padding">Videos</div>
              <!-- <a [href]='"/#/playback?"+videoNumber?.videoLink' target="_blank"
                *ngFor='let videoNumber of detail?.videoDisplayNumber'> -->
              <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
              <!-- <div class="video-link">
                  <span>{{ videoNumber?.videoId }}</span>
                </div> -->
              <!--</div> -->
              <!-- </a> -->
              <div *ngIf="APP_SETTINGS.isRollsRoyce  == 'true'">
                <a [href]='"/tisUI/?linemake=ROLLSROYCE#/playback?"+videoNumber?.videoLink' target="_blank"
                  *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                  <div class="video-link">
                    <span>{{ videoNumber?.videoId }}</span>
                  </div>
                </a>
              </div>
              <div *ngIf="APP_SETTINGS.isRollsRoyce  != 'true'">
                <a [href]='"/tisUI/#/playback?"+videoNumber?.videoLink' target="_blank"
                  *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                  <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
                  <div class="video-link">
                    <span>{{ videoNumber?.videoId }}</span>
                  </div>
                  <!--</div> -->
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="shareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" #modalCloseButton class="close" data-dismiss="modal"
              style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Only Mobile hTML5 goes here... -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">

    <div class="bmw-xs-bulletin-main" #bulletinContent>
      <div style="margin:0px;">
        <!-- <ul class="nav nav-tabs">
          <li role="presentation" *ngFor='let detail of bulletinDetail;let i=index' (click)="smoothScroll('#detail'+i)" [class.bmw-xs-nav-sections-active]="sectionHtmlId==='#detail'+i">
            <a>{{detail?.title}}</a>
          </li>
        </ul> -->
        <div class="bmw-xs-bulletin-content-header">
          <div class="row bmw-no-gutter">
            <div class="col-xs-1 bmw-no-gutter">
              <div (click)='navigateBack()'>
                <i class="material-icons dp48">arrow_back</i>
              </div>
            </div>
            <div class="col-xs-11" style="display:flex; justify-content:inline-flex">
              <div class="col-xs-7"></div>
              <div class="col-xs-1" style="margin-right:15px">
                <!-- <i class="material-icons bmw-small-icons" (click)='printBulletin()'>print</i> -->
              </div>
              <div class="col-xs-1" style="margin-right:15px">
                <i class="material-icons bmw-small-icons" data-toggle="modal" data-target="#shareContent"
                  (click)='shareContent(bulletin?.bulletinDisplayId, "bulletin", bulletin?.bulletinType, bulletin?.bulletinDisplayNumber)'>share</i>
              </div>
              <div class="col-xs-1" style="margin-right:15px" (click)='toggleSave()'>
                <i class="material-icons bmw-small-icons">star_border</i>
              </div>
            </div>
          </div>
          <div class="row bmw-no-gutter">
            <div class="alert alert-danger row bmw-no-gutter" *ngIf="!bulletin">{{bulletinServiceError}}</div>
            <div *ngIf="bulletin" style="padding-left:5px">
              <div class="row bmw-no-gutter">
                <div class="col-xs-6 bmw-no-gutter">{{ bulletin?.bulletinDisplayNumber }}</div>
                <div class="col-xs-6 bmw-align-text-right ">{{ bulletin.releaseDate | date: 'yyyy-MM-dd' }}</div>
              </div>
              <div class="row bmw-no-gutter">
                <div class="col-xs-12 bmw-bold-font bmw-no-gutter">{{ bulletin.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bulletin-xs-content flex-container row" data-scroll="scroll" [hidden]="!isLoaded">
        <div *ngFor='let detail of bulletinDetail'>

          <div class="bmw-bulletin-section" *ngIf='detail?.title === "Legacy"'>
            <!-- <div class="bulletin-detail-title">{{detail?.title}}</div> -->
            <div style="word-wrap: break-word" [innerHTML]='detail?.descriptionRich'></div>
          </div>

          <div class="bmw-bulletin-section" *ngIf='detail?.title === "Supporting Materials"'>
            <div class="bulletin-detail-title supporting-materials-padding">{{detail?.title}}</div>
            <div *ngIf='bulletinFiles?.length > 0'>
              <div *ngIf='bulletinType.toLowerCase() === "sib"'>
                <a [href]='"mount/sib_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                  <div class="bmw-bulletin-detail-files">
                    <i class="material-icons"
                      [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                    </i>
                    <span>{{ file?.fileName }}</span>
                  </div>
                </a>
              </div>
              <div *ngIf='bulletinType.toLowerCase() === "tri"'>
                <a [href]='"mount/tri_attachments/"+file?.fileName' target="_blank" *ngFor='let file of bulletinFiles'>
                  <div class="bmw-bulletin-detail-files">
                    <i class="material-icons"
                      [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>
                      {{ file?.fileName?.substr(-4).includes('pdf') ? 'picture_as_pdf' : 'insert_drive_file'}}
                    </i>
                    <span>{{ file?.fileName }}</span>
                  </div>
                </a>
              </div>

            </div>
            <div class="bmw-bulletin-section"
              *ngIf='detail?.videoDisplayNumber && detail?.videoDisplayNumber.length > 0'>
              <div class="bulletin-detail-title supporting-materials-padding">Videos</div>
              <!-- <a [href]='"/#/playback?"+videoNumber?.videoLink' target="_blank"
                *ngFor='let videoNumber of detail?.videoDisplayNumber'> -->
              <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
              <!-- <div class="video-link">
                  <span>{{ videoNumber?.videoId }}</span>
                </div> -->
              <!--</div> -->
              <!-- </a> -->
              <div *ngIf="APP_SETTINGS.isRollsRoyce  == 'true'">
                <a [href]='"/tisUI/?linemake=ROLLSROYCE#/playback?"+videoNumber?.videoLink' target="_blank"
                  *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                  <div class="video-link">
                    <span>{{ videoNumber?.videoId }}</span>
                  </div>
                </a>
              </div>

              <div *ngIf="APP_SETTINGS.isRollsRoyce  != 'true'">
                <a [href]='"/tisUI/#/playback?"+videoNumber?.videoLink' target="_blank"
                  *ngFor='let videoNumber of detail?.videoDisplayNumber'>
                  <!--<div class="video-link" (click)="openVideo(videoNumber)"  *ngFor='let videoNumber of detail?.videoDisplayNumber' >-->
                  <div class="video-link">
                    <span>{{ videoNumber?.videoId }}</span>
                  </div>
                  <!--</div> -->
                </a>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="shareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" #modalCloseButton class="close" data-dismiss="modal"
              style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>